import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { useSelector, useDispatch } from 'react-redux'
import { addUserHome, setOrgId, getOrgId, getTypeButton, setTypeButton, setUserHomeDetails, setOrgData, setLoading, clearWorkflowMessage } from '../reducer/dashboardSlice';
import { useEffect } from 'react';
export default function MenuTab(props) {
  const {handleHome, _handleIconCLick, menuTitle,selectedTab,setSelectedTab} = props;
  const typeButton = useSelector(getTypeButton);
  const [value, setValue] = React.useState(selectedTab ? selectedTab : typeButton);
  const orgId = useSelector(getOrgId);
  const dispatch = useDispatch();
  useEffect(() => {
    setValue(selectedTab ? selectedTab : typeButton)
  }, [selectedTab, typeButton])

  const handleChange = (event,newValue) => {
    setSelectedTab(newValue);
    setValue(newValue);
    let value = 0;
    if(newValue === 'Tests' || newValue === 'Feedback' || newValue === 'Survey' || newValue === 'WorkFlow' ){
        value = 0;
    }else if(newValue === 'Completed' || newValue === 'FeedbackCompleted' || newValue === 'CompletedSurvey' || newValue === 'CompletedWorkFlow'){
        value = 1;
    }else{
        // eslint-disable-next-line unused-imports/no-unused-vars
        value = 2;
    }
    let data = {
        newValue: newValue,
        org : orgId,

    }

    dispatch(clearWorkflowMessage());
    dispatch(setLoading(true));
    dispatch(addUserHome(data)).then((response)=>{
        dispatch(setUserHomeDetails(response.payload))
        dispatch(setTypeButton(newValue))
        // dispatch(setGroupDetails(response.payload.groups))
        dispatch(setOrgId(response.payload.latestOrg))
        dispatch(setOrgData(response.payload.org))
        let typeData = response.payload;
        handleHome(typeData,newValue)
        dispatch(setLoading(false))
      }).catch((e)=>{
          console.log(e)
          dispatch(setLoading(false))
      })
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs
        variant="scrollable"
        value={value}
        key={value}
        onChange={handleChange}
        textColor="secondary"
        indicatorColor="secondary"
        aria-label="scrollable secondary tabs"
      >
        <Tab key={menuTitle[0]} value={menuTitle[0]} label={
          menuTitle[0] === 'Tests' ? "Pending Test" :
          menuTitle[0] === 'Survey' ? "Pending Survey" :
          menuTitle[0] === 'WorkFlow' ? 'Pending WorkFlow' :
          menuTitle[0] === 'Disabled Groups' ? 'Disabled Tests' :
          "Pending Feedback"
        }/>
        <Tab key={menuTitle[1]} value={menuTitle[1]} label={
          menuTitle[1] === 'Completed' ? "Completed Test" :
          menuTitle[1] === 'SurveyCompleted' ? "Completed Survey" :
          menuTitle[1] === 'WorkFlowCompleted' ? 'Completed WorkFlow' :
          menuTitle[1] === 'Disabled Feedback' ? 'Disabled Feedback' :
          "Completed Feedback"
        }/>
        <Tab key={menuTitle[2]} value={menuTitle[2]} label={
          menuTitle[2] === 'Expired' ? "Expired Test" :
          menuTitle[2] === 'SurveyExpired' ? "Expired Survey" :
          menuTitle[2] === 'WorkFlowExpired' ? 'Expired WorkFlow' :
          menuTitle[2] === 'Disabled Survey' ? 'Disabled Survey' :
          "Expired Feedback"
        }/>
      </Tabs>
    </Box>
  );
}